import { render } from "./LeaderboardView.vue?vue&type=template&id=26ae5a5e&scoped=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"

import "./LeaderboardView.vue?vue&type=style&index=0&id=26ae5a5e&scoped=true&lang=css"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ae5a5e"]])

export default __exports__